import clsx from "clsx";
import React, { useState } from "react";

import PinchZoomImage from "../../PinchZoomImage";

type Props = {
  image: File | string;
  imageList: (File | string)[];
  index: number;
  onRemove?: (index: number) => void;
  className?: string;
  wrapperClassName?: string;
  label?: string;
  remainCount?: number;
};

export default function ImagePreview({
  image,
  imageList,
  index,
  onRemove,
  className,
  wrapperClassName,
  label,
  remainCount,
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = (e: React.MouseEvent) => {
    e.stopPropagation(); // 이벤트 버블링을 중단합니다.
    setIsModalOpen(false);
  };

  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.(index);
  };
  return (
    <div
      onClick={handleImageClick}
      className={clsx(["relative", wrapperClassName])}
    >
      {image && (
        <img
          src={typeof image === "string" ? image : URL.createObjectURL(image)}
          alt=""
          className={clsx([
            "min-w-[100px] w-[calc((100vw-60px)/3)] h-[calc((100vw-60px)/3)] object-cover",
            className,
          ])}
        />
      )}
      {onRemove && (
        <div
          className="absolute top-0 right-0 cursor-pointer"
          onClick={handleRemoveClick}
        >
          <CloseButton />
        </div>
      )}

      {imageList && (
        <PinchZoomImage
          imageList={imageList}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}

      {label && (
        <div className="absolute left-0 top-0 py-1 px-[5px] bg-brand-primary-gray-100 text-white text-[10px] font-semibold">
          {label}
        </div>
      )}

      {remainCount !== undefined && (
        <div className="absolute right-0 bottom-0 bg-brand-primary-gray-100 bg-opacity-40 text-white py-1 px-[5px] flex gap-[5px] text-[10px] font-semibold">
          <span>{remainCount}</span>
          <span>+</span>
        </div>
      )}
    </div>
  );
}

export const CloseButton = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.579 7.1496L7.37817 16.3504"
      stroke="white"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M7.37817 7.1496L16.579 16.3504"
      stroke="white"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
